import { SearchSm, XCircle } from '@aktiia/design-system';
import cx from 'classnames';

import { ISearchInputProps } from './types';

export const SearchInput = ({ value, onChange, placeholder, className }: ISearchInputProps) => {
  const clearText = () => onChange('');

  return (
    <div className="flex flex-1 relative items-center">
      <div className="absolute left-4">
        <SearchSm className="text-text-quartenary" />
      </div>

      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder ?? undefined}
        className={cx(className, 'h-[48px] pl-12 pr-12')}
      />

      <div className="absolute right-4">
        {value?.length !== 0 && <XCircle className="cursor-pointer" onClick={clearText} />}
      </div>
    </div>
  );
};
